import React, {useState} from 'react';
import {PlusCircleOutlined, UnorderedListOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined} from '@ant-design/icons';
import {Layout, Menu, Typography, Flex, Button, Tooltip} from 'antd';
import {useNavigate} from "react-router-dom";
import {useAuth} from "../funcs/Authcontext";

const {Sider} = Layout;
const {Text} = Typography;

const menuItems = [
    {
        label: 'Парсинг',
        key: 'main',
        icon: <UnorderedListOutlined/>,
    },
    {
        label: 'Добавить задачу',
        key: 'addtask',
        icon: <PlusCircleOutlined/>,
    },
];

export default function Sidebar() {
    const navigate = useNavigate();
    const {logoutUser} = useAuth();
    const [collapsed, setCollapsed] = useState(false);
    const [current, setCurrent] = useState(
        localStorage.getItem("currentpage") || "main"
    );

    const onClick = (e) => {
        setCurrent(e.key);
        localStorage.setItem("currentpage", e.key);
        navigate("/" + e.key);
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("userid");
        localStorage.removeItem("username");
        localStorage.removeItem("authed");
        localStorage.removeItem("currentpage");
        logoutUser();
        navigate("/login");
    };

    const username = localStorage.getItem("username") || "User";

    return (
        <Sider
            collapsible
            collapsed={collapsed}
            onCollapse={setCollapsed}
            className="app-sider"
            width={220}
            trigger={null}
        >
            <div className="sider-logo">
                {collapsed ? (
                    <Text strong style={{fontSize: 18, color: '#a017ff'}}>ZP</Text>
                ) : (
                    <Text strong style={{fontSize: 18, color: '#a017ff'}}>Zoro Parser</Text>
                )}
            </div>

            <div className="sider-collapse-btn" onClick={() => setCollapsed(!collapsed)}>
                {collapsed ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>}
            </div>

            <Menu
                onClick={onClick}
                selectedKeys={[current]}
                mode="inline"
                items={menuItems}
                style={{borderRight: 'none', flex: 1}}
            />

            <div className="sider-footer">
                {!collapsed && (
                    <Text type="secondary" ellipsis style={{marginBottom: 8, display: 'block', textAlign: 'center'}}>
                        {username}
                    </Text>
                )}
                <Tooltip title="Выйти" placement="right">
                    <Button
                        type="text"
                        danger
                        icon={<LogoutOutlined/>}
                        onClick={handleLogout}
                        block
                    >
                        {!collapsed && 'Выйти'}
                    </Button>
                </Tooltip>
            </div>
        </Sider>
    );
}
